import { render } from "./Announcement.vue?vue&type=template&id=eaf8a870&scoped=true"
import script from "./Announcement.vue?vue&type=script&lang=js"
export * from "./Announcement.vue?vue&type=script&lang=js"

import "./Announcement.vue?vue&type=style&index=0&id=eaf8a870&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eaf8a870"]])

export default __exports__